import { colors, fonts } from '../../../../../css';

export const muiGlobalTheme = {
  palette: {
    action: { disabled: colors.colorGrey04 },
    primary: { main: colors.colorBlue, dark: colors.colorBlue },
    text: { disabled: colors.colorGrey03, primary: colors.colorGrey03, secondary: colors.colorBlue }
  },
  typography: { fontFamily: fonts.fontRegular },
  overrides: {
    MuiIconButton: {
      root: {
        marginButton: '0'
      }
    },
    MuiInput: {
      underline: {
        '&:before': { borderBottom: `2px solid ${colors.colorGrey04}` },
        '&:hover:not($disabled):not($focused):not($error):before': { borderBottom: `2px solid ${colors.colorGrey03}` },
        '&:after': { borderBottom: `2px solid ${colors.colorBlue}` }
      }
    }
  }
};
